import React, { useState, useEffect, useRef } from 'react';
import api from '../services/api';

// Campo "Comprado de" do cadastro de veículo (entrada = compra): autocomplete sobre os
// clientes da empresa (nome ou CPF/CNPJ) + mini-cadastro inline via POST /clientes/rapido.
const inpStyle = { width: '100%', padding: '8px 10px', background: '#F4F6F9', border: '0.5px solid rgba(26,58,92,0.15)', borderRadius: '7px', color: '#1C2533', fontSize: '13px', fontFamily: "'DM Sans',system-ui,sans-serif", boxSizing: 'border-box' };
const lbl = { color: '#6B7A8D', fontSize: '11px', fontWeight: '600', display: 'block', marginBottom: '5px', textTransform: 'uppercase', letterSpacing: '0.3px' };
const btn = { padding: '6px 12px', borderRadius: '6px', cursor: 'pointer', fontSize: '12px', fontWeight: '600', fontFamily: "'DM Sans',system-ui,sans-serif" };
const soDigitos = s => String(s || '').replace(/\D/g, '');

export default function CompradoDe({ value, onChange }) {
  const [clientes, setClientes] = useState([]);
  const [busca, setBusca] = useState('');
  const [aberto, setAberto] = useState(false);
  const [novo, setNovo] = useState(null); // null = fechado; objeto = mini-form aberto
  const [salvando, setSalvando] = useState(false);
  const caixa = useRef();

  useEffect(() => { api.get('/clientes').then(r => setClientes(r.data)).catch(() => {}); }, []);
  useEffect(() => {
    const fora = e => { if (caixa.current && !caixa.current.contains(e.target)) setAberto(false); };
    document.addEventListener('mousedown', fora);
    return () => document.removeEventListener('mousedown', fora);
  }, []);

  const selecionado = clientes.find(c => c.id === parseInt(value));
  const termo = busca.trim().toLowerCase();
  const dig = soDigitos(busca);
  const resultados = termo.length < 2 ? [] : clientes.filter(c =>
    (c.nome || '').toLowerCase().includes(termo) || (dig.length >= 3 && soDigitos(c.cpf_cnpj).includes(dig))
  ).slice(0, 8);

  const escolher = c => { onChange(c.id); setBusca(''); setAberto(false); setNovo(null); };

  const salvarNovo = async () => {
    setSalvando(true);
    try {
      const r = await api.post('/clientes/rapido', novo);
      setClientes(cs => cs.some(c => c.id === r.data.id) ? cs : [...cs, r.data]);
      if (r.data.ja_existia) alert('Já existe cliente com esse CPF/CNPJ: ' + r.data.nome + '. Ele foi vinculado ao veículo.');
      escolher(r.data);
    } catch (e) { alert(e.response?.data?.error || 'Erro ao cadastrar'); }
    finally { setSalvando(false); }
  };

  return (
    <div style={{ marginBottom: '12px', gridColumn: '1 / -1' }} ref={caixa}>
      <label style={lbl}>Comprado de</label>
      {selecionado ? (
        <div style={{ ...inpStyle, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <span><b>{selecionado.nome}</b> <span style={{ color: '#6B7A8D' }}>· {selecionado.cpf_cnpj || 'sem CPF/CNPJ'}</span></span>
          <button type='button' onClick={() => onChange(null)} style={{ background: 'none', border: 'none', color: '#C0392B', cursor: 'pointer', fontSize: '12px' }}>Trocar</button>
        </div>
      ) : novo ? (
        <div style={{ border: '0.5px solid rgba(26,58,92,0.2)', borderRadius: '8px', padding: '12px', background: '#FAFBFC' }}>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '8px' }}>
            {[['Nome completo *', 'nome'], ['CPF/CNPJ *', 'cpf_cnpj'], ['Telefone *', 'telefone'], ['Endereço (opcional)', 'endereco']].map(([l, k]) => (
              <div key={k}>
                <label style={lbl}>{l}</label>
                <input value={novo[k] || ''} onChange={e => setNovo(n => ({ ...n, [k]: e.target.value }))} style={inpStyle} />
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', gap: '8px', marginTop: '10px', justifyContent: 'flex-end' }}>
            <button type='button' onClick={() => setNovo(null)} style={{ ...btn, background: 'transparent', border: '1px solid rgba(26,58,92,0.2)', color: '#6B7A8D' }}>Cancelar</button>
            <button type='button' onClick={salvarNovo} disabled={salvando} style={{ ...btn, background: '#1A3A5C', border: 'none', color: '#fff' }}>{salvando ? 'Salvando...' : 'Salvar e vincular'}</button>
          </div>
        </div>
      ) : (
        <div style={{ position: 'relative' }}>
          <input placeholder='Buscar cliente por nome ou CPF/CNPJ...' value={busca}
            onChange={e => { setBusca(e.target.value); setAberto(true); }} onFocus={() => setAberto(true)} style={inpStyle} />
          {aberto && termo.length >= 2 && (
            <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff', border: '0.5px solid rgba(26,58,92,0.2)', borderRadius: '7px', boxShadow: '0 4px 14px rgba(0,0,0,0.1)', zIndex: 10, maxHeight: '240px', overflowY: 'auto' }}>
              {resultados.map(c => (
                <div key={c.id} onMouseDown={() => escolher(c)}
                  style={{ padding: '8px 10px', cursor: 'pointer', fontSize: '13px', borderBottom: '0.5px solid rgba(26,58,92,0.06)' }}>
                  <b>{c.nome}</b> <span style={{ color: '#6B7A8D', fontSize: '12px' }}>· {c.cpf_cnpj || 'sem CPF/CNPJ'}</span>
                </div>
              ))}
              {resultados.length === 0 && <div style={{ padding: '8px 10px', fontSize: '12px', color: '#9AA3AE' }}>Nenhum cliente encontrado</div>}
              <div onMouseDown={() => { setNovo({ nome: dig.length >= 11 ? '' : busca, cpf_cnpj: dig.length >= 11 ? busca : '' }); setAberto(false); }}
                style={{ padding: '8px 10px', cursor: 'pointer', fontSize: '13px', color: '#185FA5', fontWeight: '600' }}>
                + Cadastrar novo
              </div>
            </div>
          )}
        </div>
      )}
    </div>
  );
}
